export default "__VITE_ASSET__07efa0f1__"